import { render, staticRenderFns } from "./image-element.vue?vue&type=template&id=878aa9e0&scoped=true"
import script from "./image-element.vue?vue&type=script&lang=js"
export * from "./image-element.vue?vue&type=script&lang=js"
import style0 from "./image-element.vue?vue&type=style&index=0&id=878aa9e0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878aa9e0",
  null
  
)

export default component.exports